import {useState} from 'react';
import {I18n} from '@aws-amplify/core';

import {FormDrawer} from './FormDrawer';
import {buildCreateInput} from '../forms/buildInput';
import {emptyProductValues} from '../forms/buildInitialValues';
import {useCreateProductMutation} from '../hooks/useProductsQuery';

export const AddFormDrawer = ({opened, onClose}: { opened: boolean, onClose: () => void }) => {

    const {mutateAsync} = useCreateProductMutation();
    const [initialValues] = useState(emptyProductValues);

    return (
        <FormDrawer
            title={I18n.get('New product')}
            initialValues={initialValues}
            handleSubmit={(values) => mutateAsync(buildCreateInput(values))}
            opened={opened}
            onClose={onClose}
        />
    );
};
